import { delay, Observable, of, switchMap, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ProfileForm, Pupil } from '@lyceo/homi/pupils/util-models';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import {
  PersonProfileDto,
  UpdatePupilCoursesDto,
} from './+state/pupil/pupil.dto';

@Injectable({
  providedIn: 'root',
})
export class PupilService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);

  public patchPupilProfile(id: string, body: ProfileForm): Observable<Pupil> {
    return of({ id, personId: '123', ...body }).pipe(
      delay(1000),
      switchMap(() => throwError(() => new Error('Simulated error'))),
    );
    /*const url: string = `/api/pupils/${id}/profile`;
    const headersToSend: HttpHeaders = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/merge-patch+json');
    return this.http.patch<Pupil>(url, body, {
      headers: headersToSend,
    });*/
  }

  public getPersonProfile(id: string): Observable<PersonProfileDto> {
    const url: string = `${this.environment.homiApiUrl}/api/persons/${id}/profile`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<PersonProfileDto>(url, {
      headers: headersToSend,
    });
  }

  public updatePupilCourses(
    personId: string,
    body: UpdatePupilCoursesDto,
  ): Observable<void> {
    const url: string = `${this.environment.homiApiUrl}/api/pupils/${personId}/courses`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.put<void>(url, body, {
      headers: headersToSend,
    });
  }
}
